<template>
    <ErrorPage
            :title="$t('errors.404.title')"
            :description="$t('errors.404.description')"
            @back="back"
    />
</template>

<script>
    import { ErrorPage } from "@tech_hexeko/design-system"

    export default {
        components: {
            ErrorPage
        },
        methods: {
            back() {
                this.$router.push({
                    path: '/',
                    root: true
                })
            }
        }
    }
</script>